import Api from 'utils/api'

export const deleteData = (model: string, pk: string | number) =>
  Api.delete([model, pk])

export const fetchData = (
  model: string,
  pk: string | number,
  payload?: Record<string, unknown>,
) => Api.get([model, pk], payload)

export const patchData = (
  model: string,
  pk: string | number,
  payload: Record<string, unknown>,
) => Api.patch([model, pk], payload)

// `pk` and `suffix` are optional path segments: RestApi filters falsy
// segments out of the URL, so callers pass undefined to skip them.
export const postData = (
  model: string,
  pk: string | number | undefined,
  suffix: string | undefined,
  payload: Record<string, unknown>,
) => Api.post([model, pk, suffix], payload)
